export const getPercentage = (val: number, percentage: number) => {
    return ((val / 100) * percentage);
};